//
// Utility Plugin for setting the configuration
//
import { setConfig } from './utils/config';
var BVConfigPlugin = {
  install: function install(Vue) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setConfig(config);
  }
};
export default BVConfigPlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/bv-config.js
// module id = odg0
// module chunks = 0